export type AbbreviationMap = ReadonlyMap<string, string>;

export interface AbbreviationExpansionResult {
	value: string;
	cursorPosition: number;
}

interface ExpandAbbreviationAtCursorOptions {
	value: string;
	previousValue: string;
	cursorPosition: number | null | undefined;
	abbreviationMap: AbbreviationMap | null | undefined;
}

export function expandAbbreviationAtCursor({
	value,
	previousValue,
	cursorPosition,
	abbreviationMap,
}: ExpandAbbreviationAtCursorOptions): AbbreviationExpansionResult | null {
	if (!abbreviationMap?.size) return null;
	if (cursorPosition === null || cursorPosition === undefined) return null;
	if (value.length !== previousValue.length + 1) return null;

	const insertedCharacterIndex = cursorPosition - 1;
	if (insertedCharacterIndex < 0 || value[insertedCharacterIndex] !== " ") {
		return null;
	}

	const beforeCursor = value.slice(0, cursorPosition);
	const afterCursor = value.slice(cursorPosition);
	const match = beforeCursor.match(/(\b\w+)\s$/);
	if (!match) return null;

	const trigger = match[1];
	const replacement = abbreviationMap.get(trigger);
	if (!replacement) return null;

	const wordStart = beforeCursor.length - match[0].length;
	const newBefore = `${beforeCursor.slice(0, wordStart)}${replacement} `;

	return {
		value: newBefore + afterCursor,
		cursorPosition: newBefore.length,
	};
}
